import { Text, Box, Flex, MenuItem, Checkbox, Divider } from "@chakra-ui/react";
import { useState, useEffect, useCallback } from "react";
import { useSelector } from "react-redux";
import { useQuery } from "react-query";
import questionnaireService from "api/issb/questionnaire.service";
import { useAuth } from "context";
import { typedId } from "api/issb/reportdoc.service";
import PageHeader from "components/text/PageHeader";
import { Sparkle } from "@phosphor-icons/react";
import { colors } from "theme/foundations/colors";

/**
 * Note: copy-pasta from AIReviewSourcesPanel -- but changing to be over rounds not files
 *
 * must pick/confirm sources before proceeding
 *
 */
export default function ReportDocSourcesPanel({ setNextDisabled, sourceTypedIds, setSourceTypedIds, hideTips }) {
  const roundSelector = useSelector((state) => state.issbRound);
  const selectedRound = roundSelector?.selectedRound;
  const { getAccessTokenSilently } = useAuth();
  const { data: questionnairePage } = useQuery(["questionnaireService.list", "all"], async () => {
    await getAccessTokenSilently();
    return questionnaireService.list({ sort: "createdDate", direction: "desc" });
  });

  const isAllSelected = sourceTypedIds?.length === questionnairePage?.content?.length;
  const selectAll = () => {
    setSourceTypedIds(isAllSelected ? [] : questionnairePage?.content?.map((q) => typedId("IssbQuestionnaire", q.id)));
  };

  // you must select at least one source
  useEffect(() => {
    setNextDisabled(sourceTypedIds?.length === 0);
  }, [sourceTypedIds, setNextDisabled]);

  const checkboxOnChange = (id, isChecked) => {
    const tid = typedId("IssbQuestionnaire", id);
    let newSourceIds;
    if (isChecked) {
      newSourceIds = [...sourceTypedIds, tid];
    } else {
      newSourceIds = sourceTypedIds.filter((q) => q !== tid);
    }
    setSourceTypedIds(newSourceIds);
  };

  console.log('selected rounds => ',questionnairePage?.content);

  return (
    <Box>
      <PageHeader
        superTitle="Report Generator"
        title="Select Disclosure Rounds"
        subTitle="Select the rounds you want ESG360 AI to use in report and answer writing. Only content from selected rounds will be used."
      />
      {/* <Text mb={4}>
        Select the rounds you want ESG360 AI to use in report and answer writing. Only content from selected rounds will
        be used.
      </Text> */}
      <Box flexGrow={1} mt={4}>
        <Flex mb={2} p={2} direction="row" gap={2}>
          <Checkbox colorScheme="limeShade" isChecked={isAllSelected} onChange={(e) => selectAll()} />
          <Text color={isAllSelected ? "gray.600" : "gray.400"} onClick={() => selectAll()}>
            Select all
          </Text>
        </Flex>
        {selectedRound && (
          <Flex key={selectedRound?.id} mb={2} p={2} direction="row" gap={2} cursor="pointer">
            <Checkbox
              colorScheme="limeShade"
              isChecked={sourceTypedIds?.includes(typedId("IssbQuestionnaire", selectedRound.id))}
              onChange={(e) => checkboxOnChange(selectedRound.id, e.target.checked)}
            />
            <Text
              color="gray.600"
              onClick={() =>
                checkboxOnChange(
                  selectedRound.id,
                  !sourceTypedIds?.includes(typedId("IssbQuestionnaire", selectedRound.id))
                )
              }
            >
              Current Round: {selectedRound.name}
            </Text>
          </Flex>
        )}
        <Divider my={4} />
        {questionnairePage?.content?.map((q) => (
          <Flex key={q.id} mb={2} p={2} direction="row" gap={2} cursor="pointer">
            <Checkbox
              colorScheme="limeShade"
              isChecked={sourceTypedIds?.includes(typedId("IssbQuestionnaire", q.id))}
              onChange={(e) => checkboxOnChange(q.id, e.target.checked)}
            />
            <Text
              color="gray.600"
              onClick={() => checkboxOnChange(q.id, !sourceTypedIds?.includes(typedId("IssbQuestionnaire", q.id)))}
            >
              {q.name}
            </Text>
          </Flex>
        ))}
      </Box>
    </Box>
  );
}
